
jQuery(document).ready( function($){

	$(window).load( function(){

		if( $('.redirects.list .trash.icon').length ) {
			$('.redirects.list .trash.icon').parent().click( function(e){
				var button = $(this);
				e.preventDefault();
				swal({
			        title: "Are you sure?",
			        text: "This action cannot be reversed",
			        type: "warning",
			        showCancelButton: true,
			        confirmButtonClass: 'btn-danger',
			        confirmButtonText: 'Yes, delete it!',
			        cancelButtonText: "No, cancel please!",
			        closeOnConfirm: false,
			        closeOnCancel: false
		        }, function( isConfirm ) {
			        if ( isConfirm ) {
			            window.location = button.attr('href');
			        } else {
			            swal.close();
			        }
			    });
			});
		}

	});

});